export default function(x) {
  return x === null ? NaN : +x;
}



//////////////////
// WEBPACK FOOTER
// ./~/d3/~/d3-array/src/number.js
// module id = /GtL
// module chunks = 0